import axios from '@/api'

export default {
  fetchVehicles({ commit }, payload){
    return new Promise((resolve, reject) => {
      if(payload.page){
        commit('SET_CURRENT_PAGE', payload.page)
      }
      axios.get('/admin/vehicles/',{params: payload})
      .then((response) => {
        commit('UPDATE_VEHICLES', response.data)
        resolve(response.data)
      })
      .catch((error) => { reject(error.response) })
    })
  },
  getVehicles({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.get('/admin/vehicles/',{params: payload})
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  MassLoadVehicles({ commit }, formData){
    return new Promise((resolve, reject) => {
      axios.post('/admin/vehicles/import/',formData,{headers: { 'Content-Type': 'multipart/form-data' } })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  }, 
  CheckVehiclesProgress({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.get('/admin/vehicles/import/'+payload.task_id+'/progress/',{params: payload})
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  fetchVehiclesReport({ commit },payload){ 
    return new Promise((resolve, reject) => {
      axios.get(`/admin/vehicles/`, {params:  payload , headers:{
        responseType: 'blob'
    }, responseType: 'blob' })
          .then((response) => {
            
            resolve(response.data)
          })
          .catch((error) => { reject(error) })
    })
  },
  storeVehicle({commit},payload){
    return new Promise((resolve, reject)=>{
      axios.post('/admin/vehicles/',payload)
        .then(response=>{
          resolve(response.data);
        })
        .catch(error =>{
          reject(error.response)
        })
    })
  },
  getVehicle({ commit },payload){
    return new Promise((resolve, reject) => {
      axios.get('/admin/vehicles/'+payload.id+'/')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  updateVehicle({ commit },payload){
    return new Promise((resolve, reject) => {
      let url = '/admin/vehicles/'+payload.id+'/';
      delete payload.id;
      axios.put( url ,payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  deleteVehicle({ commit },payload){
    return new Promise((resolve, reject) => {
      axios.delete('/admin/vehicles/'+payload.id+'/')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error.response) })
    })
  },
}
